import OAuthSuccess from "@/views/Integrations/OAuthSuccess";
import OAuthError from "@/views/Integrations/OAuthError";

export default [
  {
    path: "integrations/oauth/success",
    name: "IntegrationsOAuthSuccess",
    component: OAuthSuccess,
  },
  {
    path: "integrations/oauth/error",
    name: "IntegrationsOAuthError",
    component: OAuthError,
  },
];
